import { API_ROUTE_ADMIN_FEATURE_SALES_PITCH } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

type FeatureSalesPitchOriginal = {
  id: number
  featureId: number
  countryId: number
  version: number
  salesPitch: string
  createdAt: string
  updatedAt: string
}

export const getFeatureSalesPitch = (featureId: number) =>
  get<FeatureSalesPitchOriginal>(
    API_ROUTE_ADMIN_FEATURE_SALES_PITCH.replace(':featureId', String(featureId)),
    IS_NEW_BACKEND_API
  )
